export default "__VITE_ASSET__CfozF7su__"